import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  // {
  //   displayName: 'Términos de Negociación',
  //   iconName: 'solar:widget-add-line-duotone',
  //   route: '/nexus/terminos-negociacion'
  // },
  // {
  //   displayName: 'Administración Roles',
  //   iconName: 'solar:notes-minimalistic-broken',
  //   route: '/nexus/admin-roles'
  // },
  // {
  //   displayName: 'Administración Menús',
  //   iconName: 'solar:documents-minimalistic-outline',
  //   route: '/nexus/admin-menus'
  // },
  // {
  //   displayName: 'Administración Usuarios',
  //   iconName: 'solar:users-group-rounded-outline',
  //   route: '/nexus/admin-usuarios'
  // },
  // {
  //   displayName: 'Administración Acciones',
  //   iconName: 'solar:graph-linear',
  //   route: '/nexus/admin-acciones'
  // }
];
